"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      hoveredTab: null,
      imgCodeList: [{
        url: require("../../assets/img/weixinpublic.jpg"),
        text: '扫描关注微信公众号'
      }, {
        url: require("../../assets/img/ios.jpg"),
        text: '下载IOS小程序'
      }, {
        url: require("../../assets/img/weixin.jpg"),
        text: '下载安卓小程序'
      }],
      navTabList: [{
        name: '订舱'
      }, {
        name: '我的订舱'
      }, {
        name: '订舱(日本)'
      }, {
        name: '订舱'
      }, {
        name: '我的订舱'
      }, {
        name: '订舱(日本)'
      }],
      tabList: [{
        name: '船期查询'
      }, {
        name: '船舶动态&汇率'
      }, {
        name: '货物跟踪'
      }],
      navList: [{
        name: '首页',
        path: '/basicInfo/userGuide'
      }, {
        name: '船期',
        path: '/basicInfo/product'
      }, {
        name: '订舱',
        path: '/basicInfo/solution'
      }, {
        name: '信息查询',
        path: '/basicInfo/service'
      }, {
        name: '进口',
        path: '/basicInfo/about'
      }, {
        name: '箱管',
        path: '/basicInfo/contact'
      }]
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  methods: {
    handleSetLanguage: function handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('app/setLanguage', lang);
      /* 刷新 */
      // this.$message({
      //   message: this.language === 'zh' ? '语言切换成功' : 'Switch Language Success',
      //   type: 'success'
      // })
    },
    handleGoLogin: function handleGoLogin() {
      // this.$router.push('/login')
    },
    hoverTabLeave: function hoverTabLeave() {
      this.hoveredTab = null;
      this.navTabList = [];
    },
    handleClick: function handleClick(index) {
      if (index === 0) {
        this.$router.push({
          path: '/home'
        });
      }
    },
    hoverTab: function hoverTab(index) {
      this.hoveredTabBox = index;
      this.hoveredTab = index;
      if (index === 4) {
        this.navTabList = [{
          name: this.$t('home.importOne'),
          path: '/delivery'
        }, {
          name: this.$t('home.importTwo'),
          path: '/cargoInfoSearch'
        }, {
          name: this.$t('home.importThree'),
          path: '/import/blExchangeAppointment'
        }, {
          name: this.$t('home.importFour'),
          path: '/basicInfo/service'
        }, {
          name: this.$t('home.importFive'),
          path: '/import/blExchangeAppointmentSh'
        }, {
          name: this.$t('home.importSix'),
          path: '/basicInfo/contact'
        }];
      }
      if (index === 2) {
        this.navTabList = [{
          name: this.$t('home.controlOne'),
          path: '/bookingSpace/bookingSpaceList'
        }, {
          name: this.$t('home.controlTwo'),
          path: '/basicInfo/product'
        }, {
          name: this.$t('home.controlThree'),
          path: '/basicInfo/solution'
        }, {
          name: this.$t('home.controlFour'),
          path: '/basicInfo/service'
        }, {
          name: this.$t('home.controlFive'),
          path: '/basicInfo/about'
        }, {
          name: this.$t('home.controlSix'),
          path: '/basicInfo/contact'
        }, {
          name: this.$t('home.controlSeven'),
          path: '/basicInfo/contact'
        }, {
          name: this.$t('home.controlEight'),
          path: '/basicInfo/contact'
        }, {
          name: this.$t('home.controlNine'),
          path: '/basicInfo/contact'
        }];
      }
      if (index === 3) {
        this.navTabList = [{
          name: this.$t('home.infoOne'),
          path: '/cargoTrack'
        }, {
          name: this.$t('home.infoTwo'),
          path: '/release'
        }, {
          name: this.$t('home.infoThree'),
          path: '/dangerCargoSpecContainer'
        }, {
          name: this.$t('home.infoFour'),
          path: '/surchargeAndMiscellaneous'
        }, {
          name: this.$t('home.infoFive'),
          path: '/carbonCalculator'
        }, {
          name: this.$t('home.infoSix'),
          path: '/basicInfo/contact'
        }];
      }
      if (index === 5) {
        this.navTabList = [{
          name: this.$t('home.containerOne'),
          path: '/equipmentFee'
        }, {
          name: this.$t('home.containerTwo'),
          path: '/containerInfo'
        }, {
          name: this.$t('home.containerThree'),
          path: '/tariffs'
        }, {
          name: this.$t('home.containerFour'),
          path: '/demurrageCalculation'
        }];
      }
      if (index === 1) {
        this.navTabList = [{
          name: this.$t('home.vesselOne'),
          path: '/voyagePlanSearch'
        }, {
          name: this.$t('home.vesselTwo'),
          path: '/vesselMovementSearch'
        }, {
          name: this.$t('home.vesselThree'),
          path: '/vesselInfo'
        }];
      }
    }
  }
};